<template>
    <h2 class="text-center">Our Choice</h2>
    <featured-top-spot-tyre :tyre="tyre" :basket="basket" :postcode="postcode" :banners="banners"></featured-top-spot-tyre>
</template>
<script>
    export default {
        props: ['tyre', 'basket', 'postcode', 'banners'],
        components: { },
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        },
        computed: {

        }
    }
</script>